"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyButton = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const StyledButton = (0, material_1.styled)(material_1.Button, {
  shouldForwardProp: prop => prop !== "showShadow"
})(({
  showShadow
}) => showShadow ? {
  [`&.${material_1.buttonClasses.contained}`]: {
    boxShadow: "none",
    "&:active": {
      boxShadow: "none"
    }
  }
} : {});
const StyledTooltipDiv = (0, material_1.styled)("div")({
  display: "inline-block"
});

const SskyButton = props => {
  const renderButton = () => {
    return react_1.default.createElement(StyledButton, {
      id: props.id,
      className: props.className,
      variant: props.variant,
      color: props.color || "secondary",
      disabled: props.disabled,
      onClick: props.onClick,
      onMouseEnter: props.onMouseEnter,
      autoFocus: props.autoFocus,
      "data-testid": props.dataTestId || `testId-${props.id || props.label}`,
      "data-tracking-id": props.dataTrackingId || `tracking-id-${props.id || props.label}`,
      sx: theme => ({
        margin: props.hasOwnProperty("margin") ? props.margin : theme.spacing(1)
      }),
      showShadow: props.showShadow
    }, props.iconLocation === "left" ? props.icon : props.label, props.iconLocation === "left" ? props.label : props.icon);
  };

  return react_1.default.createElement(react_1.default.Fragment, null, props.tooltip ? react_1.default.createElement(SskyTooltip_1.default, {
    title: props.tooltip,
    placement: props.tooltipPlacement,
    enterDelay: props.tooltipEnterDelay
  }, react_1.default.createElement(StyledTooltipDiv, null, renderButton())) : renderButton());
};

exports.SskyButton = SskyButton;
SskyButton.defaultProps = {
  color: "primary",
  showShadow: false,
  variant: "contained",
  tooltipPlacement: "top"
};
exports.default = react_1.default.memo(SskyButton);